// AUTO-GENERATED by scripts/set-env.js — do not edit manually
// Environment: dev
export const environment = {
  "production": false,
  "envLabel": "dev",
  "nestApiUrl": "https://func-nest-ui-dev-ard0fqaggrdwgbg9.centralus-01.azurewebsites.net/api/nest-lookup",
  "nestApiKeyHeader": "",
  "nestApiKeyValue": "",
  "aadTenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  "aadClientId": "3c59f166-7807-494c-ac61-169b9fe8c114",
  "apiScope": "api://nest-ui-dev.chevron.com/access_as_user",
  "showPipeFab": true,
  "appInsightsConnectionString": "InstrumentationKey=2702ec11-caa0-41ba-8d83-6efea348bb5e;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=5629ece5-c53a-4c7f-8051-8eb3a276c344"
};
